import { createSlice } from '@reduxjs/toolkit';

const InvoiceDetailsDataSlice = createSlice({
    name: 'InvoiceDetailsData',
    initialState: '',
    reducers: {
        setInvoiceDetailsData: (state, action) => {
            return action.payload;
        },
        resetInvoiceDetailsData: (state) => {
            return null;
        },
    },
});

export const { setInvoiceDetailsData, resetInvoiceDetailsData } = InvoiceDetailsDataSlice.actions;
export default InvoiceDetailsDataSlice.reducer;